/**
 * Cliente HTTP de las segmentaciones: wrappers tipados sobre `req()` de campana-nueva, como la base de ventas. Nunca se
 * manda el comercio (sale del token). Por ahora todo es del equipo: con el token de una persona de un cliente, 403.
 */

import { descargarBinario, req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import { slug } from "./logic/segmentar";
import type * as T from "./types";

const B = "/activa/segmentaciones";
const e = (id: string) => encodeURIComponent(id);

export const segmentacionesApi = {
  listar: (): Promise<Resp<T.Segmentacion[]>> => req("GET", B),
  /** Arranca en segundo plano (202): la pantalla la consulta hasta que termina. */
  crear: (pctControl: number): Promise<Resp<T.Segmentacion>> => req("POST", B, { pctControl }),
  /** Los grupos armados en un Excel (una hoja por grupo y la del control), en base64: la campaña vuelve lista (201). */
  importar: (nombreArchivo: string, contenido: string): Promise<Resp<T.Segmentacion>> => req("POST", `${B}/importar`, { nombreArchivo, contenido }),
  /** «Con los grupos de tu Público»: de qué segmentación salen los grupos y cuántas personas van en cada uno. No crea nada. */
  desdePublico: (): Promise<Resp<T.GruposDelPublico>> => req("GET", `${B}/desde-publico`),
  /**
   * Crea la campaña con esos grupos y un control nuevo (201): vuelve lista para Grupos y Mensajes. `desde`: la segmentación
   * que se mostró; si el Público ya tiene otra, 409 GRUPOS_CAMBIARON.
   */
  crearDesdePublico: (pctControl: number, desde: string): Promise<Resp<T.Segmentacion>> => req("POST", `${B}/desde-publico`, { pctControl, desde }),
  ver: (id: string): Promise<Resp<T.Segmentacion>> => req("GET", `${B}/${e(id)}`),
  renombrar: (id: string, nombre: string): Promise<Resp<T.Segmentacion>> => req("PATCH", `${B}/${e(id)}`, { nombre }),
  /** Los nombres comerciales de los grupos (del equipo): quedan para las próximas campañas de la marca. */
  nombrar: (id: string, nombres: Record<string, string>): Promise<Resp<T.Segmentacion>> => req("PUT", `${B}/${e(id)}/nombres`, { nombres }),
  excel: (s: Pick<T.Segmentacion, "id" | "nombre">): Promise<void> => descargarBinario(`${B}/${e(s.id)}/excel`, `${slug(s.nombre)}-publicos.xlsx`),
  pdf: (s: Pick<T.Segmentacion, "id" | "nombre">): Promise<void> => descargarBinario(`${B}/${e(s.id)}/pdf`, `${slug(s.nombre)}-reporte.pdf`),
};
